import React, { Component } from 'react';
import { ErrorMessage, Form, Formik } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { dynamicSort } from '../../../../common/utils/api_utils';
import CustomSelectGroup from '../../../../common/formElements/CustomSelectGroup';
import {
  getTemplateCollectionFieldOptions,
  getProjectConstantOptions,
  getSessionOptions,
} from './SmsFieldsUtil';

export default class SmsTemplateForm extends Component {
  createSchemaForFields = () => {
    const { templateId, numberFields } = this.props.smsTemplateRule;
    return {
      templateId: templateId || '',
      numberFields: numberFields || '',
    };
  };

  getSmsTemplateOptions = () => {
    let options = [{ value: '', label: '-Select One-' }];
    let templateOptions = this.props.smsTemplates
      .filter((item) => !item.parentTemplateId)
      .sort(dynamicSort('name'))
      .map((item, key) => ({ value: item.uuid, label: item.name }));
    return [...options, ...templateOptions];
  };

  getNumberFieldsOptions = (templateId) => {
    const { collections, smsTemplates, projectDetail } = this.props;
    const selectedTemplate = smsTemplates ? smsTemplates.find((e) => e.uuid === templateId) : null;
    const templateCollectionName = selectedTemplate ? selectedTemplate.collectionId : null;
    const templateCollection =
      collections && templateCollectionName
        ? collections.find((e) => e.collectionName === templateCollectionName)
        : null;
    let options = getTemplateCollectionFieldOptions(templateCollection, collections);
    let projectConstantOptions = getProjectConstantOptions(projectDetail);
    let sessionOptions = getSessionOptions(collections);
    let groupedOptions = [
      {
        label: 'Fields',
        options: options,
      },
      {
        label: 'Project Constant',
        options: projectConstantOptions,
      },
      {
        label: 'Current LoggedIn User',
        options: sessionOptions,
      },
    ];

    return groupedOptions;
  };

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  closeAllOpenPopup = () => {
    this.props.closeAllOpenPopup();
  };

  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createSchemaForFields()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label>{'SMS Template'}*</label>
                  <CustomSelect
                    name="templateId"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getSmsTemplateOptions()}
                    value={values['templateId']}
                  />
                  <ErrorMessage name={'templateId'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select a template you want to send via this event.</small>
                </div>
                <div className="form-group">
                  <label>{'Phone Number Fields'}*</label>
                  <CustomSelectGroup
                    name="numberFields"
                    isMulti={true}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getNumberFieldsOptions(values['templateId'])}
                    value={values['numberFields']}
                  />
                  <ErrorMessage name={'page'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                  <small>Select the phone number field.</small>
                </div>
              </div>
            </div>
            {this.props.children}
          </Form>
        )}
      </Formik>
    );
  }
}
